export default {
  deposit: {
    crypto: 'Cripto',
    fiatOrCash: 'Fiat/Efectivo',
    depositCurrency: 'Moneda de depósito',
    chooseNetwork: 'Elegir red',
    depositAddress: 'Dirección de depósito',
    copy: 'Copiar',
    copied: '¡Copiado!',
    close: 'Cerrar',
    more: 'Más',
    select: 'Seleccionar',
    channel: 'Canal',
    loading: 'Cargando...',
    noCurrency: 'No hay monedas disponibles',
    bonusTip: 'Disfruta de un bono de depósito en tu primera recarga, con hasta un 200% de crédito adicional.',
    minDeposit: 'Depósito mínimo',
    sendOnly: 'Envía solo {currency} a esta dirección de depósito. Las monedas se depositarán automáticamente tras {confirmations} confirmaciones de la red.',
    depositAmount: 'Importe del depósito',
    enterAmount: 'Introduce el importe',
    confirmDeposit: 'Confirmar depósito',
    depositTitle: 'Depósito',
    selectChannel: 'Seleccionar canal',
    subtitle: 'Rápido, seguro y cómodo',
    secureEncrypted: 'Seguro y cifrado',
    terms: 'Al continuar, aceptas nuestros Términos y Condiciones',
    totalDepositAmount: 'Importe total del depósito',
    fee: 'Comisión',
    arrivalAmount: 'Importe abonado',
    payMethod: 'Método de Pago',
    cpf: 'CPF',
    enterCpf: 'Por favor ingrese su CPF',
    depositSuccess: '¡Depósito realizado con éxito!',
    depositFailed: 'Error en el depósito, inténtalo de nuevo.',
    mockArrive: 'Llegada simulada (Prueba)',
    activity: {
      firstChargeTitle: 'Evento de registro de primera recarga',
      firstChargeSubtitle: 'Registra tu primer depósito para recibir recompensas exclusivas',
      dailyThreeTitle: 'Tres recargas diarias',
      dailyThreeSubtitle: 'Completa 3 depósitos al día para reclamar bonos adicionales',
      dailyPreviewLabel: 'Recompensa de primera recarga',
      upTo: 'Hasta {amount} {unit}',
      safeTitle: 'Tus fondos están seguros con nosotros',
      safeDesc: 'Usamos seguridad líder del sector para proteger tus transacciones e información personal.',
      dailyFirst: '1.ª recarga diaria',
      dailySecond: '2.ª recarga diaria',
      dailyThird: '3.ª recarga diaria',
      lossReward: 'Reembolso por pérdidas',
      lossRewardSubtitle: 'Recibe reembolso sobre tus pérdidas',
      rebateUpTo: 'Reembolso de hasta {ratio}%',
      notEligible: 'Ya no puedes participar en esta actividad',
      lossNeedSelect: 'Selecciona esta actividad al depositar para participar en el reembolso',
      claimed: 'Reclamado',
      claim: 'Reclamar',
      noTier: 'Sin niveles',
      claimWillOpen: 'La reclamación abre a las {time}',
      claimTimeNotReached: 'La reclamación aún no está abierta. Vuelve después de las {time}.',
      bonus: 'Bono',
      rebate: 'Reembolso',
      depositGE: 'Depósito ≥ {amount}',
      lossGE: 'Pérdida ≥ {amount}',
      claimSuccess: 'Reclamado con éxito',
      claimFailed: 'Reclamación fallida',
      alreadyClaimed: 'Ya has reclamado este nivel. No vuelvas a hacer clic.',
      lossAlreadyClaimed: 'Ya has reclamado el reembolso de este nivel. No vuelvas a hacer clic.',
      requireLogin: 'Inicia sesión antes de reclamar.',
      depositNotEnough: 'Tu importe de depósito aún no cumple el requisito. ¡Sigue así!',
      lossNotEnough: 'Tu pérdida de ayer no cumple el requisito.',
      onlyHighest: 'Esta recompensa solo permite reclamar el nivel más alto.',
    },
  },
};
